import type { TFunction } from 'i18next'

type ConnectedUser = { status: string, lastConnectionAt?: unknown }

/**
 * Dernière connexion, ou « jamais » pour un compte qui ne s'est pas encore
 * activé. Partagée par la colonne de la liste et l'export CSV, qui doivent
 * dire la même chose.
 *
 * Le croisement avec le statut n'est pas cosmétique : `lastConnectionAt` porte
 * un `@default(now())` en base, si bien qu'un compte jamais connecté affiche
 * sa date d'INVITATION. Sans cette lecture, la colonne annoncerait une
 * connexion qui n'a pas eu lieu — et c'est exactement sur elle qu'on repère
 * les invitations restées sans suite.
 */
export function lastConnectionLabel(t: TFunction, locale: string, user: ConnectedUser): string {
  if (user.status === 'PENDING_ACTIVATION' || !user.lastConnectionAt) {
    return t('user.lastConnection.never')
  }
  return new Date(user.lastConnectionAt as string).toLocaleString(locale)
}
